import { React, PT, withRouter } from '@gasbuddy/react';
import moment from 'moment';
import { Table } from 'semantic-ui-react';

function last(i) {
  return i && i.extra_data && i.extra_data.last_digits;
}

function pname(p, i) {
  if (p === 'gasbuddy') {
    if (i === 'network_card') {
      return 'GasBuddy/ADS💳';
    }
    return 'GasBuddy/WEX';
  }
  return p;
}

function hasBadTags(i) {
  return i?.extra_data?.tags
    && (
      i.extra_data.tags.includes('nsf')
      || i.extra_data.tags.includes('inactive')
      || i.extra_data.tags.includes('secondary-failed')
    );
}

const BaseInstrumentTable = ({ instruments, history }) => {
  const hasExplicitDefault = instruments.some(i => i.extra_data?.tags?.includes('default-bank'));
  const isDefault = i => (hasExplicitDefault
    ? i.extra_data?.tags?.includes('default-bank')
    : i.billable);
  return (
    <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Provider</Table.HeaderCell>
          <Table.HeaderCell>Created</Table.HeaderCell>
          <Table.HeaderCell width={2}>Last</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {instruments.map(i => (
          <Table.Row
            error={hasBadTags(i)}
            warning={!!i.deleted}
            className={i.deleted ? 'deleted' : null}
            key={i.instrument_account_map_id}
            onClick={() => history.push(`/payments/instrument-map/${i.instrument_account_map_id}`)}
          >
            <Table.Cell>
              {pname(i.provider_name, i.instrument_type)}
              {isDefault(i) && '💸'}
            </Table.Cell>
            <Table.Cell>{moment(i.created).format('MM/DD/YY')}</Table.Cell>
            <Table.Cell>{last(i)}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

BaseInstrumentTable.propTypes = {
  instruments: PT.arrayOf(PT.shape({
    provider_name: PT.string.isRequired,
    instrument_type: PT.string.isRequired,
    created: PT.string.isRequired,
    instrument_account_map_id: PT.number.isRequired,
  })),
  history: PT.shape({ push: PT.func }).isRequired,
};

BaseInstrumentTable.defaultProps = {
  instruments: [],
};

export const InstrumentTable = withRouter(BaseInstrumentTable);
